import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { GoogleMap, LoadScript, Polygon, Marker, KmlLayer } from '@react-google-maps/api';
import AWS from 'aws-sdk';
import toastr from "toastr";

const MapComponent = ({ apiKey, polygons, onPolygonClick, selectedPolygon }) => {

    const defaultCenter = { lat: -19.95107568011385, lng: -43.99014893060838 };
    const [mapOptions, setMapOptions] = useState({
        mapTypeId: 'satellite',
        defaultZoom: 11,
        kmlData: [], // Array para armazenar dados dos KMLs dinâmicos
        selectedKml: null, // Armazenar informações sobre o KML selecionado
        center: null,
        minZoom: 4,
        restriction: {
            latLngBounds: {
                north: 85,
                south: -85,
                west: -180,
                east: 180
            },
            strictBounds: true,
        }
    });

    const mapStyles = {
        width: '100%',
        height: 'calc(100vh - 1px)',
        position: 'absolute',
        overflow: 'hidden',
        top: '0',
        bottom: '0px',
        right: '0',
        left: '0',
        zIndex: 2,
    };

    const inputRefs = useRef([]);
    const refMap = useRef();

    const onDragEnd = () => {
        document.getElementById('panelMarkNavigate').style.opacity = 1;
    }

    const onDragStart = () => {
        document.getElementById('panelMarkNavigate').style.opacity = 0.3;
    }

    useEffect(() => {

        if (selectedPolygon !== null && inputRefs && inputRefs.current) {

            let center = { lat: mapOptions.kmlData[selectedPolygon].state.kmlLayer.getDefaultViewport().getCenter().lat(), lng: mapOptions.kmlData[selectedPolygon].state.kmlLayer.getDefaultViewport().getCenter().lng() }
            setMapOptions((prevOptions) => ({ ...prevOptions, center, zoom: 11 }));
            
            // const map = refMap.current.getInstance();
            // const latLng = new window.google.maps.LatLng(mapOptions.kmlData[selectedPolygon].state.kmlLayer.getDefaultViewport().getCenter().lat(), mapOptions.kmlData[selectedPolygon].state.kmlLayer.getDefaultViewport().getCenter().lng());
            // var bounds = new window.google.maps.LatLngBounds(
            //     new window.google.maps.LatLng(mapOptions.kmlData[selectedPolygon].state.kmlLayer.getDefaultViewport().getNorthEast().lat(),mapOptions.kmlData[selectedPolygon].state.kmlLayer.getDefaultViewport().getSouthWest().lng()),
            //     new window.google.maps.LatLng(mapOptions.kmlData[selectedPolygon].state.kmlLayer.getDefaultViewport().getNorthEast().lat(),mapOptions.kmlData[selectedPolygon].state.kmlLayer.getDefaultViewport().getSouthWest().lng()),
            // );
            // map.panTo(latLng);
            // map.fitBounds(bounds);
        }
    }, [selectedPolygon]);

    const loadKml = useCallback((map) => {
        let kmlData = [];
        if (inputRefs && inputRefs.current) {
            kmlData = inputRefs.current;

            setMapOptions((prevOptions) => ({ ...prevOptions, kmlData }));

        }

    }, []);

    // const loadKmlLayer = useCallback((kmlLayer) => {
    //     console.log('kml', kmlLayer);
    //     kmlLayer.set('styles', {
    //         backgroundColor: "#0000ff",
    //         fillColor: "#0000ff",
    //         strokeColor: "0000ff",
    //       });
    // }, []);


return (
    <LoadScript googleMapsApiKey={apiKey}>
        <GoogleMap ref={refMap} className="map-content" onLoad={loadKml} mapContainerStyle={mapStyles} center={mapOptions.center} zoom={mapOptions.defaultZoom} options={mapOptions} onCenterChanged={selectedPolygon == null} onDragEnd={onDragEnd} onDragStart={onDragStart}>
            {polygons && polygons.length > 0 && polygons.map((kml, index) => (
                <KmlLayer
                    key={index}
                    ref={ref => { inputRefs.current[index] = ref }}
                    url={kml.url}
                    onClick={() => onPolygonClick(index)}
                    // onLoad={loadKmlLayer}
                />
            ))}
        </GoogleMap>
    </LoadScript>
);
};

export default MapComponent;